const guideData = {
  germany:     () => import('./germany'),
  usa:         () => import('./usa'),
  uk:          () => import('./uk'),
  canada:      () => import('./canada'),
  australia:   () => import('./australia'),
  china:       () => import('./china'),
  sweden:      () => import('./sweden'),
  japan:       () => import('./japan'),
  france:      () => import('./france'),
  italy:       () => import('./italy'),
  spain:       () => import('./spain'),
  netherlands: () => import('./netherlands'),
  denmark:     () => import('./denmark'),
  norway:      () => import('./norway'),
  finland:     () => import('./finland'),
  switzerland: () => import('./switzerland'),
  austria:     () => import('./austria'),
  belgium:     () => import('./belgium'),
  hungary:     () => import('./hungary'),
  poland:      () => import('./poland'),
  portugal:    () => import('./portugal'),
  ireland:     () => import('./ireland'),
  turkey:      () => import('./turkey'),
  malaysia:    () => import('./malaysia'),
  india:       () => import('./india'),
  indonesia:   () => import('./indonesia'),
  southkorea:  () => import('./south-korea'),
  russia:      () => import('./russia'),
  saudiarabia: () => import('./saudi-arabia'),
  singapore:   () => import('./singapore'),
  newzealand:  () => import('./new-zealand'),
  pakistan:    () => import('./pakistan'),
  romania:     () => import('./romania'),
  qatar:       () => import('./qatar'),
  thailand:    () => import('./thailand'),
  uae:         () => import('./uae'),
};

export default guideData;